module.exports = __webpack_public_path__ + "img/maisonette-2.79eeb9bc.webp";